import axios from "axios";
import { notifyWorkspaceMutation } from "./workspaceEvents";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Sichere Kundensicht ist nur-lesend: schreibende Aktionen werden vom Backend mit
// 403 blockiert. Statt eines stillen Fehlers zeigen wir dem Staff einen klaren Hinweis.
let _lastReadonlyToast = 0;
api.interceptors.response.use(
  (r) => { notifyWorkspaceMutation(r); return r; },
  (err) => {
    const detail = err?.response?.data?.detail;
    // Jury-Demo: abgelaufene/beendete Sitzung → zurück zur öffentlichen Landing-Seite.
    if (err?.response?.status === 401 && localStorage.getItem("sc_jury") === "1") {
      localStorage.removeItem("sc_jury");
      if (!window.location.pathname.startsWith("/jury-demo")) {
        window.location.assign("/jury-demo?ended=1");
      }
      return Promise.reject(err);
    }
    if (err?.response?.status === 403 && typeof detail === "string" && detail.startsWith("Jury-Demo:")) {
      const now = Date.now();
      if (now - _lastReadonlyToast > 1500) {
        _lastReadonlyToast = now;
        toast.info(detail.replace(/^Jury-Demo:\s*/, ""));
      }
      return Promise.reject(err);
    }
    if (err?.response?.status === 403 && typeof detail === "string" && detail.includes("nur-lesend")) {
      const now = Date.now();
      if (now - _lastReadonlyToast > 1500) {
        _lastReadonlyToast = now;
        toast.info("Kundensicht ist nur-lesend – Aktionen sind hier deaktiviert.");
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
export default api;
